export default "__VITE_ASSET__DOk5WT0q__"